import { EditUserComponent } from './edit-user/edit-user.component';
import { AddUserComponent } from './add-user/add-user.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListUsersComponent } from './list-users/list-users.component';

export const routesUser: Routes = [
    { path: 'page-cfg-user', component: ListUsersComponent },
    { path: 'page-cfg-user/add', component: AddUserComponent },
    { path: 'page-cfg-user/:id/edit', component: EditUserComponent },
];

export const UserRoutes: ModuleWithProviders = RouterModule.forChild(routesUser);
